import { Main, MasterContainer } from 'components/atoms'
import { Header } from 'components/molecules'
import { Footer } from 'components/organisms'
// import { ContextProvider } from 'provider'

export const Layout = ({ children, footerColor }) => {
  return (
    // <ContextProvider>
    <MasterContainer>
      <Header />
      <Main>{children}</Main>
      <Footer footerColor={footerColor} />
    </MasterContainer>
    // </ContextProvider>
  )
}
